// CORE
import React, { Component } from 'react'

// MODULES
import { 
	ModuleOne, 
	ModuleEighteen,
	ModuleTwelve,
	ModuleFive } from '../../../components/Modules'

// STYLES
import classes from '../layout.css'

class BoneGrafting extends Component {
	render() {
		const { addToForm, consentForm } = this.props

		return (
			<form id={consentForm.formId} className={classes.Container}>
				<h2>{consentForm.formName}</h2>

				<ModuleOne
					addToForm={addToForm} 
					consentForm={consentForm} 
				/>
				<p><strong>Please initial each paragraph after reading. If you have any questions, please ask your doctor BEFORE initialing.</strong></p>
				<ModuleEighteen
					addToForm={addToForm} 
					consentForm={consentForm} 
				/>
				<p>In addition to the risks of the primary surgical procedure which have been explained to me separately, I understand that bone grafting itself involves specific risks. My doctor has explained to me that such risks include, but are not limited to, the following:</p>
				<ModuleTwelve
					addToForm={addToForm} 
					consentForm={consentForm} 
				/>
				<h3>CONSENT</h3>
				I acknowledge that the above has been explained to my satisfaction, my questions have been answered, and I understand the risks of bone grafting. I am fully aware that a perfect result cannot be guaranteed or warranted. My signature below indicates my understanding of my proposed treatment and I hereby give my willing consent to the surgery. I certify that I speak, read, and write English.
				<ModuleFive
					addToForm={addToForm} 
					consentForm={consentForm} 
				/>
			</form>
		)
	}
}

export default BoneGrafting


// WEBPACK FOOTER //
// ./src/containers/FormLayout/Form/6.js